import React from 'react'
import { NewButton, Section, TaglineTitleContent } from 'newComponents'
import { ReactComponent as Sphere } from '../../../images/home/sphere.svg'
import { ReactComponent as SphereLayerTop } from '../../../images/home/sphere-layer-1.svg'
import { ReactComponent as SphereLayerMid } from '../../../images/home/sphere-layer-2.svg'
import { ReactComponent as SphereLayerBottom } from '../../../images/home/sphere-layer-3.svg'
import { ReactComponent as MobileStar } from '../../../images/home/single-shooting-star.svg'
import './styles.scss'

const GetDemo = () => (
  <div className="get-demo-cta-container">
    <NewButton to="/request-a-demo" eventName="Request Demo Button Clicked" chevron>
      Get a Demo
    </NewButton>
    <NewButton className="contact-sales-cta" to="/contact-sales" eventName="Contact Sales Button Clicked" chevron>
      Contact Sales
    </NewButton>
  </div>
)

const HomeHeader = (props) => {
  const { tagline, title, content, cta } = props

  const headerTaglineHtml = tagline?.html
  const headerTitleHtml = title?.html
  const headerContentHtml = content?.html

  const headerCta = {
    'Get Demo': <GetDemo />
  }

  return (
    <Section className="home-header">
      <div className="home-header-left">
        <TaglineTitleContent tagline={headerTaglineHtml} title={headerTitleHtml} content={headerContentHtml} />
        {cta && <div className="home-header-cta">{headerCta[cta]}</div>}
      </div>
      <MobileStar className="home-header-mobile-star" />
      <SphereLayerBottom className="home-header-layer-bottom" />
      <Sphere className="home-header-sphere" />
      <SphereLayerMid className="home-header-layer-mid" />
      <SphereLayerTop className="home-header-layer-top" />
    </Section>
  )
}

export default HomeHeader
